exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#omni-chat-web body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif; }\n\n#omni-chat-web #captcha {\n  display: none; }\n", ""]);

// exports
